import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, map, Observable, switchMap, take } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  constructor(private readonly auth: AuthService) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // 1) Only handle API calls
    if (!req.url.startsWith(environment.api.baseUrl)) {
      return next.handle(req);
    }

    // 2) Check authentication state
    return this.auth.isAuthenticated$.pipe(
      take(1),
      switchMap((isAuthenticated) => {
        // Not logged in → pass through unchanged
        if (!isAuthenticated) {
          return next.handle(req);
        }

        // 3) Logged in → attempt to retrieve token
        return this.auth.getAccessTokenSilently().pipe(
          take(1),
          map((token) => {
            // No token available → don't modify request
            if (!token) {
              return req;
            }

            return req.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`,
              },
              // remove this if cookies are not needed
              withCredentials: true,
            });
          }),
          switchMap((reqWithAuth) => next.handle(reqWithAuth))
        );
      })
    );
  }
}
